module.exports = __webpack_public_path__ + "media/images/ln/num_9-0a1ad1632a7ceda0e0dafe65f2b5ab04.png";